module.exports = __webpack_public_path__ + "static/media/clue-3.6cec8a34.svg";